<template>
  <v-app id="app">
    <router-view :key="$route.fullPath" />
    <!-- <navbar-bottom
      v-if="activedIndex > -1"
      :activedIndex="activedIndex"
    ></navbar-bottom> -->
    <BackToTop :isScrolled="isScrolled" :isScrolling="isScrolling" />
    <NextScreen
      v-if="isHome"
      :isScrolled="isScrolled"
      :isScrolling="isScrolling"
      :contentH="contentH"
    />
    <custom-alert-overlay
      :message-content="messageContent"
      :show-modal="showModal"
      v-on:give-showmodal="handleModal"
    />
    <CustomConfirmOverlay
      :content="confirmContent"
      :show-modal="showModalConfirm"
      @leftBtn="handleConfirmL"
      @rightBtn="handleConfirmR"
    />
  </v-app>
</template>

<script>
import BackToTop from '@/components/BackToTop.vue'
import CustomAlertOverlay from '@/components/shared/CustomAlertOverlay.vue'
import CustomConfirmOverlay from '@/components/shared/CustomConfirmOverlay.vue'
import NextScreen from '@/components/homepage/nextScreen.vue'
export default {
  name: 'app',
  data: function() {
    return {
      pageTitle: '',
      ready: false,
      isScrolling: false,
      isScrolled: false,
      isHome: false,
      contentH: 0,
      timer: null,
      messageContent: '',
      showModal: false,
      showModalConfirm: false,
      activedIndex: 0,
      alert_cb: () => {},
      showOverlay: false,
      confirmContent: {
        title: '系統訊息',
        messageContent: '',
        leftBtnText: '取消',
        rightBtnText: '確定',
      },
      confirm_left_cb: () => {},
      confirm_right_cb: () => {},
    }
  },
  components: {
    BackToTop,
    CustomAlertOverlay,
    CustomConfirmOverlay,
    NextScreen,
  },
  mounted: function() {
    if (this.ready == false) {
      this.ready = true
    }
  },
  watch: {
    $route(to, from) {
      window.scrollTo({
        top: 0,
      })
      const overlay = document.querySelector('.overlay')
      if (overlay) {
        overlay.remove()
      }
      this.activedIndex = to.meta.activedIndex
      if (to.name == 'home') {
        this.isHome = true
      } else {
        this.isHome = false
      }
    },
    isScrolled() {
      window.isScrolled = this.isScrolled
    },
  },
  methods: {
    showAlert(info) {
      this.messageContent = info.messageContent
      this.alert_cb = info.callback ? info.callback : () => {}
      this.showModal = true
    },
    showConfirm(info) {
      this.confirmContent.title = info.title || '系統訊息'
      this.confirmContent.messageContent = info.messageContent || ''
      this.confirmContent.leftBtnText = info.leftBtnText || '取消'
      this.confirmContent.rightBtnText = info.rightBtnText || '確定'
      this.confirm_left_cb = info.left_cb ? info.left_cb : () => {}
      this.confirm_right_cb = info.right_cb ? info.right_cb : () => {}
      this.showModalConfirm = true
    },
    handleModal() {
      this.showModal = false
      this.alert_cb()
      this.alert_cb = () => {}
    },
    handleConfirmL() {
      this.showModalConfirm = false
      this.confirm_left_cb()
    },
    handleConfirmR() {
      this.showModalConfirm = false
      this.confirm_right_cb()
    },
    handleScroll() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      this.isScrolled = scrollTop > 100
      this.isScrolling = true
      clearTimeout(this.timer)
      this.timer = setTimeout(this.isScrollEnd, 500)
    },
    isScrollEnd() {
      this.isScrolling = false
    },
    setNavIndex(index) {
      this.activedIndex = index
    },
    switchOverlay(showOverlay) {
      const html = document.querySelector('html')
      this.showOverlay = showOverlay

      if (showOverlay) {
        html.className = 'show-overlay'
      } else {
        html.className = ''
      }
    },
    closeOverlay() {
      this.showOverlay = false
    },
  },
  created() {
    this.$bus.$on('callAllert', this.showAlert)
    this.$bus.$on('callConfirm', this.showConfirm)
    this.$bus.$on('setNavIndex', this.setNavIndex)
    this.$bus.$on('getPiUID', this.getPiUID)
    this.$bus.$on('updateContentHeight', height => {
      this.contentH = height
    })
    // this.$bus.$on('switchOverlay', this.switchOverlay)
    this.$bus.$on('closeOverlay', this.closeOverlay)
    window.addEventListener('scroll', this.handleScroll)
    this.activedIndex = this.$route.meta.activedIndex
    window.addEventListener('callAllert', this.showAlert)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style lang="scss">
html {
  &.show-overlay {
    overflow: hidden;
  }
}

* {
  user-select: none;
  -webkit-touch-callout: none;
  touch-action: pan-x pan-y;
}
input,
textarea {
  user-select: auto;
  &:focus {
    outline: none;
  }
}
#app {
  font-family: 'SF Pro Display', 'Roboto', 'Ping Fang TC', 'Ping Fang TC', Arial,
    Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #4a4a4a;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #4a4a4a;
}

#nav a.router-link-exact-active {
  color: #222222;
}

body {
  margin: 0px;
  // padding-bottom: 49px;
  background-color: #f3f3f3;
  box-sizing: border-box;
  overflow-x: hidden;
  video,
  object,
  iframe,
  table,
  embed {
    width: 100% !important;
    height: auto !important;
  }
}

a {
  text-decoration: none;
}

.container {
  background-color: #f3f3f3;
}

.h3 {
  font-size: 18px;
}

.h4 {
  font-size: 15px;
}

.h6 {
  font-size: 13px;
}

/* Rewrites Form Elements */
.v-application {
  p {
    margin-bottom: 0;
  }
  .v-btn:not(.v-btn--round) {
    border-radius: 10px;
  }
  .v-btn:not(.v-btn--round).v-size--default {
    height: 44px;
  }
  .v-application--wrap {
    // min-height: calc(100vh - 49px) !important;
  }
  .theme--light.v-label {
    font-size: 14px;
    color: #545454;
  }
  .theme--light.v-icon {
    color: #9b9b9b;
  }
  .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: #ededed;
    border-image: none;
  }
  .theme--light {
    &.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: #8bd0fb !important;
      color: #fff !important;
    }
  }
  .v-input {
    padding-top: 16px;
    .v-label.v-label--active {
      transform: translateY(-22px) scale(0.8);
    }
  }
  .v-select {
    .v-input__icon {
      .v-icon {
        font-size: 18px;
      }
    }

    &--no-label {
      padding-top: 0;
      .v-label {
        color: #9b9b9b;
      }
      &.v-input--is-label-active,
      &.v-input--is-focused {
        .v-label {
          display: none;
        }
      }
    }
    .v-select__slot {
      .v-label {
        font-size: 12px;
        color: #767676 !important;
      }
    }
  }
  .v-input--selection-controls__input {
    margin-right: 12px;
  }
  .v-input--selection-controls__ripple:before {
    opacity: 0 !important;
  }
  .v-input--checkbox {
    .v-icon {
      border: 1px #dedede solid;
      width: 22px;
      height: 22px;
      font-size: 22px;
      border-radius: 6px;
    }

    &.v-input--is-label-active {
      .v-icon {
        border: none;
        background: radial-gradient(circle, #fff 40%, #1da7fc 41%) !important;
      }
    }

    &:not(.v-input--hide-details) .v-input__slot {
      margin-bottom: 0;
    }
  }

  .v-text-field {
    margin-top: 8px;

    &--no-label {
      padding-top: 0;
    }

    .v-text-field__slot {
      label {
        color: #9b9b9b !important;
      }
      input {
        font-size: 12px;
        color: #767676 !important;
      }
    }
    &.v-input--is-dirty {
      .v-text-field__slot input {
        font-size: 16px;
        color: #383838 !important;
      }
    }
    .v-input__slot {
      margin-bottom: 4px;
    }
    .v-text-field__details {
      color: #f22803;
    }
  }

  .v-input--radio-group {
    &.no-message {
      .v-messages {
        display: none;
      }
    }
    padding-top: 0;
    .v-radio {
      .v-icon {
        border: 1px #dedede solid;
        width: 20px;
        height: 20px;
        font-size: 28px;
        border-radius: 100%;

        &:before {
          content: '';
        }

        &.v-input--is-label-active {
          .v-icon {
            border: none;
          }
        }

        &.accent--text {
          &:before {
            content: '';
            width: 12px;
            height: 12px;
            border-radius: 100%;
            background-color: #f22803;
          }
        }
      }
      .v-label {
        &.theme--light {
          font-size: 14px;
          color: #545454;
        }
      }
      &.v-item--active {
        .v-icon {
          font-size: 0 !important;
          background: radial-gradient(circle, #1da7fc 44%, #ffffff 48%);
        }
      }
    }
  }
  .v-btn-primary {
    width: 100%;
    border-radius: 5px;
    box-shadow: none;

    &:active {
      box-shadow: none;
    }

    &.v-btn:not(.v-btn--round) {
      height: 46px;
    }

    .v-ripple__container {
      box-shadow: none;
    }

    .v-btn__content {
      color: white;
      letter-spacing: normal;
      font-size: 16px;
    }
    &.v-btn--outlined .v-btn__content {
      color: #1da7fc;
    }

    &.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: #8bd0fb !important;
      color: #fff !important;
    }
  }
}

// 不知為啥寫在AdsCarousel.vue不work，於是寫在這
.banner-carousel {
  .swiper-pagination {
    bottom: 1.1em;

    .item-inactive.item-active {
      opacity: 1;
      background-color: white;
    }
    .item-inactive {
      opacity: 1;
      margin: 0 0.1em;
      width: 1em;
      height: 0.3em;
      display: inline-block;
      background-color: #d4d0c8;
    }
  }
}

.v-menu__content,
.v-list {
  background-color: #fff;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    border-left: 10px solid white;
    border-right: 2px solid white;
    background-color: #ededed;
  }
}
</style>
